import { render, staticRenderFns } from "./RestorePage.vue?vue&type=template&id=590b0668"
import script from "./RestorePage.vue?vue&type=script&lang=js"
export * from "./RestorePage.vue?vue&type=script&lang=js"
import style0 from "./RestorePage.vue?vue&type=style&index=0&id=590b0668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports